class AvatarWrapper extends HTMLElement {
  constructor (self) {
    self = super(self)
    const rango = self.getAttribute('rango')
    const size = self.getAttribute('size')
    const typeCorrespondance = {
      grande      : 'grande',
      dia         : 'dia',
      cmedio      : 'comment', // Hackin' Verema
      ccoment     : 'comment',
      coment      : 'comment',
      comment     : 'comment',
      cthumbnail  : 'thumbnail',
      thumbnail   : 'thumbnail',
      mini        : 'mini'
    }

    var wrapper = self.querySelector('.core-AvatarWrapper')
    if (wrapper.className.indexOf('core-AvatarWrapper-') == -1) {
      wrapper.classList.add(`core-AvatarWrapper-${typeCorrespondance[size]}`)
    }

    if (rango) {
      var badge = self.querySelector('.core-UserBadge')
      if (['cthumbnail', 'thumbnail'].indexOf(size) > -1) {
        badge.classList.add('core-UserBadge-tiny')
      }
      badge.innerHTML = (rango === 'new') ? 'Nuevo' : `Top&nbsp;${rango}`
      self.classList.add('core-AvatarWrapper-with-badge')
      self.classList.add(`core-User-is-top-${rango}`)
    }

    return self
  }
}

export default AvatarWrapper
